import { render } from "./vendorCode2.vue?vue&type=template&id=232a4ca0"
import script from "./vendorCode2.vue?vue&type=script&lang=js"
export * from "./vendorCode2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__